import React, { useState, useEffect } from 'react';
import FrontHeader from '../components/common/FrontHeader';
import FrontFooter from '../components/common/FrontFooter';
import './HowItWorks.css';

// Reusing assets
import img1 from '../assets/image-7.jpeg'; 
import img2 from '../assets/image-8.jpeg'; 
import img3 from '../assets/image-11.jpeg'; 
import img4 from '../assets/image-12.jpeg'; 

const HowItWorks = () => {
  const [activeTab, setActiveTab] = useState('owner');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const content = {
    owner: [
      { id: '01', title: 'Publish Requirements', desc: 'Create a Request for Quote (RFQ) in seconds. Define your vessel service needs, select the port, and set your deadline. Our intelligent system notifies relevant verified providers instantly.', img: img1, icon: 'fa-file-signature', tag: 'Direct Posting' },
      { id: '02', title: 'Compare Industry Bids', desc: 'Receive detailed technical and commercial proposals. Compare providers based on their reputation, certifications, and previous work history to make an informed decision.', img: img2, icon: 'fa-gavel', tag: 'Smart Choice' },
      { id: '03', title: 'Escrow Protection', desc: 'Secure your transaction. Funds are deposited into a secure escrow account and are only released when the work is completed and you provide your final approval.', img: img3, icon: 'fa-lock', tag: 'Secure Funds' },
      { id: '04', title: 'Approve & Finalize', desc: 'Review the digital service report and maintenance logs uploaded by the provider. Once satisfied, release the payment with a single click. Everything is documented for your fleet records.', img: img4, icon: 'fa-check-double', tag: 'Workflow End' }
    ],
    provider: [
      { id: '01', title: 'Class-Vetted Profile', desc: 'Upload your class approvals and certifications. Once verified by our team, your company joins an elite list of providers visible to global ship managers.', img: img2, icon: 'fa-user-check', tag: 'Pro Status' },
      { id: '02', title: 'Get Smart Leads', desc: 'Stop searching for work. Get real-time alerts for RFQs that match your specific expertise and port locations directly on your dashboard.', img: img1, icon: 'fa-bullseye', tag: 'Instant Leads' },
      { id: '03', title: 'Bid Professionally', desc: 'Submit competitive quotes with technical documentation. Use our direct messaging to clarify scope and win contracts without any middlemen.', img: img4, icon: 'fa-handshake', tag: 'Win Jobs' },
      { id: '04', title: 'Guaranteed Payouts', desc: 'Forget chasing invoices. Because owners deposit funds into escrow before you start, your payment is guaranteed and released instantly upon work approval.', img: img3, icon: 'fa-wallet', tag: 'Safe Earnings' }
    ]
  };

  return (
    <div className="hiw-page">
      <FrontHeader />

      <section className="hiw-hero">
        <div className="hiw-hero-img" style={{ backgroundImage: `url(${img3})` }}></div>
        <div className="hiw-hero-overlay"></div>
        <div className="hiw-hero-content">
          <span className="sv-section-tag">The SeaZex Workflow</span>
          <h1 className="hiw-hero-title">How It <span className="hiw-highlight">Works</span></h1>
          <p className="hiw-hero-subtitle">A standardized, transparent, and secure process for global maritime operations.</p>
        </div>
      </section>

      <div className="hiw-tab-nav">
        <div className="hiw-tab-pill">
          <button className={activeTab === 'owner' ? 'active' : ''} onClick={() => setActiveTab('owner')}>Ship Owner</button>
          <button className={activeTab === 'provider' ? 'active' : ''} onClick={() => setActiveTab('provider')}>Service Provider</button>
        </div>
      </div>

      <div className="hiw-container-inner">
        {content[activeTab].map((item, index) => (
          <div key={item.id} className="hiw-journey-item">
            <div className={`hiw-row ${index % 2 !== 0 ? 'reverse' : ''}`}>
              <div className="hiw-text-side">
                <div className="hiw-step-num">{item.id}</div>
                <h2>{item.title}</h2>
                <p>{item.desc}</p>
              </div>
              <div className="hiw-image-side">
                <div className="hiw-img-wrapper">
                  <img src={item.img} alt={item.title} />
                  <div className="hiw-floating-card">
                    <i className={`fas ${item.icon}`}></i>
                    <span>{item.tag}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <FrontFooter />
    </div>
  );
};

export default HowItWorks;